export default __webpack_public_path__ + "static/media/telescopic-handler-icon.d2451b3a.svg";